import { parseTime } from '@/utils/util'

export default {
  parseTime,
  fillBlank(text, fillText = '--') {
    if (text === 0) return text // 一般我们认为在页面上显示是可以展示0的具体看情况分析
    return text || fillText
  }
}
